import { render, staticRenderFns } from "./FloorAssignmentReassign.vue?vue&type=template&id=6be7bf44"
import script from "./FloorAssignmentReassign.vue?vue&type=script&lang=js"
export * from "./FloorAssignmentReassign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports